// extracted by mini-css-extract-plugin
export var link = "_ru-0";